import { useBroadcastChannel } from 'utils/broadcastChannel/useBroadcastChannel';
import { SettingsServiceTypes } from 'common/settingsService/types';
import { SETTINGS_SERVICE_CONTEXT } from 'common/settingsService/impl/contextName';

/**
 * for internal usage only
 * @param onSettingsToggle a callback that is called when the settings are changed.
 * @returns a function to broadcast the settings to the other tabs.
 */
export function useSettingsServiceChannel(onSettingsToggle: (event: SettingsServiceTypes.ChannelEvent) => void) {
  const { broadcast } = useBroadcastChannel<SettingsServiceTypes.StateModel>(
    SETTINGS_SERVICE_CONTEXT,
    onSettingsToggle
  );
  return broadcast;
}
